<template>
    <div class="nav-media-upload">
        <div class="upload">
            <div class="nav-media-upload__section">
                <div v-if="files.length">
                    <div v-for="file in files" :key="file.id" class="nav-media-upload__file">
                        <div class="nav-media-upload__column">
                            <img
                                v-if="file.thumb"
                                :src="file.thumb"
                                width="200"
                                height="auto"
                                class="nav-media-upload__thumb"
                            >
                            <span v-else>No Image</span>
                        </div>
                        <div class="nav-media-upload__column">
                            <div class="nav-media-upload__label">{{ file.name }}</div>

                            <div class="nav-media-upload__label">
                                <label class="flex-form__field">
                                    <div class="flex-form__label">
                                        Alt Tag Value:
                                    </div>

                                    <input
                                        v-model="file.alt"
                                        class="flex-form__input"
                                        type="text"
                                    >
                                </label>
                            </div>

                            <div v-if="file.active || file.progress !== '0.00'" class="progress">
                                <div :class="{ 'nav-media-upload__progress-bar': true, 'nav-media-upload__progress-bar-striped': true, 'bg-danger': file.error, 'nav-media-upload__progress-bar-animated': file.active }" role="progressbar" :style="{ width: file.progress + '%' }">{{ file.progress }}%</div>
                            </div>
                            <div v-if="file.error" class="nav-media-upload__error">{{ file.error }}</div>
                            <div v-else-if="file.success" class="nav-media-upload__success">success</div>
                            <div v-else-if="file.active" class="nav-media-upload__active">active</div>
                            <div v-else />
                        </div>
                        <div class="nav-media-upload__column">
                            <div class="nav-media-upload__smallerlabel">{{ file.size | formatSize }}</div>
                        </div>
                        <div class="nav-media-upload__column">
                            <button type="button" class="image_control__button-secondary" @click.prevent="$refs.upload.remove(file)">Remove</button>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="nav-media-upload__upload">
                        <h4>Drop files here to upload<br>or</h4>
                        <label for="file" class="image_control__button">Select Files</label>
                    </div>
                </div>

                <div v-show="$refs.upload && $refs.upload.dropActive" class="nav-media-upload__drop-active">
                    <h3>Drop files to upload</h3>
                </div>
            </div>
            <div>
                <file-upload
                    ref="upload"
                    v-model="files"
                    :post-action="postAction"
                    :put-action="putAction"
                    :multiple="multiple"
                    :directory="directory"
                    :size="size || 0"
                    :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                    :headers="headers"
                    :data="data"
                    :drop="drop"
                    :drop-directory="dropDirectory"
                    :add-index="addIndex"
                    :custom-action="uploadMedia"
                    @input-filter="inputFilter"
                    @input-file="inputFile"
                />
            </div>
        </div>
        <div class="flex-page-data__buttons">
            <button
                v-if="files.length && (!$refs.upload || !$refs.upload.active) && !($refs.upload && $refs.upload.uploaded)"
                type="button"
                class="flex-page-data__button flex-page-data__button--continue"
                @click.prevent="$refs.upload.active = true"
            >
                START UPLOAD
            </button>

            <button
                class="flex-page-data__button flex-page-data__button--cancel"
                @click="cancel"
            >
                CLOSE
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import FileUpload from 'vue-upload-component';
import * as service from '@/sitecore/sitecore-data-service';

export default {
    name: 'media-upload',
    components: {
        FileUpload,
    },

    data() {
        return {
            files: [],
            minSize: 0,
            size: 1024 * 1024 * 10,
            multiple: true,
            directory: false,
            drop: true,
            dropDirectory: true,
            addIndex: false,
            thread: 3,
            name: 'file',
            putAction: service.getMediaUploadParameters().postAction,
            postAction: service.getMediaUploadParameters().postAction,
            headers: service.getMediaUploadParameters().headers,
            data: service.getMediaUploadParameters().params,
            uploadAuto: false,
            isOption: false,
            addData: {
                show: false,
                name: '',
                type: '',
                content: '',
            },
        };
    },

    computed: {
        ...mapState({
            parentPath: ({ page }) => page.newPagePath,
        }),
    },

    methods: {
        inputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Before adding a file
                // Filter system files or hide files
                if (
                    /(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)
                ) {
                    return prevent();
                }
                // Filter aspx html js file
                if (/\.(aspx?|html?|js?)$/i.test(newFile.name)) {
                    return prevent();
                }
            }

            if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                // Create a blob field
                newFile.blob = '';
                const url = window.URL || window.webkitURL;
                if (url && url.createObjectURL) {
                    newFile.blob = url.createObjectURL(newFile.file);
                }
                // Thumbnails
                newFile.thumb = '';
                if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                    newFile.thumb = newFile.blob;
                }
            }
        },
        // add, update, remove File Event
        inputFile(newFile, oldFile) {
            if (newFile && oldFile) {
                // update
                if (newFile.active && !oldFile.active) {
                    // beforeSend
                    // min size
                    if (
                        newFile.size >= 0
                        && this.minSize > 0
                        && newFile.size < this.minSize
                    ) {
                        this.$refs.upload.update(newFile, { error: 'size' });
                    }
                }
                if (newFile.progress !== oldFile.progress) {
                    // progress
                }
                if (newFile.error && !oldFile.error) {
                    // error
                }
                if (newFile.success && !oldFile.success) {
                    // success
                }
            }
            if (!newFile && oldFile) {
                // remove
                if (oldFile.success && oldFile.response.id) {
                    // $.ajax({
                    //   type: 'DELETE',
                    //   url: '/upload/delete?id=' + oldFile.response.id,
                    // })
                }
            }
            // Automatically activate upload
            if (
                Boolean(newFile) !== Boolean(oldFile)
                || oldFile.error !== newFile.error
            ) {
                if (this.uploadAuto && !this.$refs.upload.active) {
                    this.$refs.upload.active = true;
                }
            }
        },

        async uploadMedia(file, component) {
            file.data.fileName = file.name;
            file.data.parent = this.parentPath;
            file.data.alt = file.alt;
            // update header post login
            file.headers = service.getMediaUploadParameters().headers;
            return component.uploadPut(file);
        },

        reset() {
            this.files = [];
        },

        cancel() {
            this.$emit('cancel');
        },
    },
};
</script>

<style lang="scss">
.nav-media-upload {
    margin: 15px;
    padding-bottom: 15px;

    &__buttons {
        position: sticky;
        display: flex;
        bottom: 0;
    }

    &__drop-active {
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        position: fixed;
        z-index: 9999;
        opacity: 0.6;
        text-align: center;
        background: var(--mediaUpload-backgroundColor);
    }

    &__drop-active h3 {
        margin: -0.5em 0 0;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        font-size: 40px;
        color: var(--sidebar-color);
        padding: 0;
    }

    &__upload {
        text-align: center;
        padding: 10px;
        color: var(--sidebar-color);
        background-color: rgba(125, 125, 125, .2);

        &:hover {
            background-color:  rgba(209, 209, 209, 0.2);
        }
    }

    &__file {
      display: grid;
      width: 100%;
      grid-template-columns: 1fr 2fr 1fr 1fr;
      margin-bottom: 15px;
      padding: 10px;
      box-shadow: 0px 0px 0px 2px rgba(155,155,155,0.2);

      &:hover {
        background-color: rgba(155,155,155,0.1);
      }
    }

    &__thumb {
      border: solid 1px #ccc;
    }

    &__column {
      display: flex;
      flex-direction: column;
      padding: 5px;
    }

    &__smallerlabel {
      font-size: smaller;
    }

    &__error {
      font-size: smaller;
      color: red;
      text-align: left;
    }

    &__success {
      font-size: smaller;
    }

    &__active {
      font-size: smaller;
    }

    &__label {
      display: block;
      font-size: smaller;
      margin-bottom: 15px;
    }

    &__progress-bar {
      font-size: small;
      background-color: var(--mediaUpload-processSuccessColor);
      margin-top: 5px;
      color: var(--mediaUpload-buttonColor);
    }

    &__progress-bar-striped {
      font-size: x-small;
      background-color: var(--mediaUpload-processActiveColor);
      color: var(--mediaUpload-buttonColor);
      text-align: right;
    }

    &__progress-bar-error {
      font-size: x-small;
      background-color: var(--mediaUpload-processErrorColor);
      text-align: right;
      color: var(--mediaUpload-buttonColor);
    }
}

.bg-danger {
    font-size: x-small;
    background-color: var(--mediaUpload-processErrorColor);
    text-align: right;
}

.image_control {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        position: relative;

        &__remove {
            position: absolute;
            top: -1.75rem;
            right: 0;
            font-size: 11px;
            color: var(--form-deleteLinkColor);

            &:hover {
                color: var(--form-deleteLinkHoverColor);
            }
        }

        &__remove-icon {
            margin-right: 3px;
        }

        &__label {
            display: block;
            font-size: 12px;
            margin-top: 5px;
        }

        &__button {
            @extend %button;
            font-size: 13px;
            padding: 6px 24px;
            min-width: inherit;
            color: var(--form-buttonColor);
            background-color: var(--form-buttonBackgroundColor);

            &:hover {
                background-color: var(--form-buttonHoverBackgroundColor);
                color: var(--form-buttonHoverColor);
            }
        }

        &__button-secondary {
            @extend %button;
            font-size: 13px;
            padding: 6px 24px;
            min-width: inherit;
            color: var(--mediaUpload-altButtonColor);
            background-color: var(--mediaUpload-altButtonBackgroundColor);

            &:hover {
                background-color: var(--mediaUpload-altButtonHoverBackgroundColor);
                color: var(--mediaUpload-altButtonHoverColor);
            }
        }
    }
</style>
